export const FallbackBanner = () => (
  <div className="font-mono text-sm text-text-dim mb-4">
    <span className="text-accent-alt-ink">// </span>
    showing cached snapshot · live data unavailable on this network
  </div>
);
